import {useTranslation} from "next-i18next";
import { Trans } from 'react-i18next';
import MediaWithText from "./MediaWithText";
import UnserTeam from "./UnserTeam";
import HomeBanner from "./HomeBanner";
import ContactFormSection from "./ContactFormSection";
import Button from "./Button";

interface WeitereLeistungenInterface {
	heading: string;
	desc: string;
	bullets: string[];
	img: string;
	moreText: string;
}


function ContactUsContent() {
	const {t} = useTranslation();

	const services = t("pages.weitereLeistungen.services", {
		returnObjects: true
	}) as WeitereLeistungenInterface[];

	const idsToRemove = [0];
	const servicesFiltered = services.filter((_, index) => !idsToRemove.includes(index));

	return (
		<>
			<div className="max-w-[1280px] mx-auto px-6">
				<div className="mt-12" />
				<div id="immobilienverwaltung">

					<MediaWithText
						textInLeft={false}
						videoSrc="https://media.leon-inmobiliaria.com/media/video/uber-uns.mp4"
						videoThumb={"/images/aboutUs/aboutus-video-thumb.png"}
						heading={t("aboutUs.s1.heading")}
						aspectRatio="aspect-[1380/775]"
					>
						<div>
							<p className="mb-6">
								<Trans i18nKey="aboutUs.s1.p1" components={{ 
									strong: <strong />,
									br: <span style={{ display: "block", height: "24px" }} />
								}} />
							</p>
						
							<p>{t('aboutUs.s1.p2')}</p>
							<p>{t('aboutUs.s1.p3')}</p>
							<p>{t('aboutUs.s1.p4')}</p>
							<p>{t('aboutUs.s1.p5')}</p>
							<p>{t('aboutUs.s1.p6')}</p>
							<p>{t('aboutUs.s1.p7')}</p>
							<p>{t('aboutUs.s1.p8')}</p>
							<p>{t('aboutUs.s1.p9')}</p>

							<p className="mt-6">
								<Trans i18nKey="aboutUs.s1.p10" components={{ 
									strong: <strong />,
									a: <a href="#contact" className="underline text-leo-brown" />
								}} />
							</p>
						</div>
					</MediaWithText>
				</div>
				<div className="mt-12" />
				<div id="unserteam">
					<UnserTeam />
				</div>
				<div className="mt-12" />
				<div id="poolpflege">
					<MediaWithText
						textInLeft={true}
						imageSrc={"/images/aboutUs/poolplege.png"}
						heading={t("aboutUs.s2.heading")}
						aspectRatio="aspect-[1376/1083]"
					>
						<div>
							<p className="mb-6">
								<Trans i18nKey="aboutUs.s2.p1" components={{ strong: <strong /> }} />
							</p>
						
							<p>{t('aboutUs.s2.p2')}</p>
							<p>{t('aboutUs.s2.p3')}</p>
							<p>{t('aboutUs.s2.p4')}</p>
							<p>{t('aboutUs.s2.p5')}</p>
							<p>{t('aboutUs.s2.p6')}</p>
							<p>{t('aboutUs.s2.p7')}</p>
							<p>{t('aboutUs.s2.p8')}</p>
							<p>{t('aboutUs.s2.p9')}</p>
							<p>{t('aboutUs.s2.p10')}</p>
							<p>{t('aboutUs.s2.p11')}</p>
							<p>
								<Trans i18nKey="aboutUs.s2.p12" components={{ br: <br /> }} />
							</p>
							<p>
								<Trans i18nKey="aboutUs.s2.p13" components={{ br: <br /> }} />
							</p>

							<p className="mt-6">
								<Trans i18nKey="aboutUs.s2.p14" components={{ 
									strong: <strong />,
									a: <a href="#contact" className="underline text-leo-brown" />
								}} />
							</p>
						</div>
					</MediaWithText>
				</div>
				

				<div className="mt-12" />

				<div id="reinigungsservice">
					<MediaWithText
						textInLeft={false}
						imageSrc={"/images/aboutUs/reinigungsservice.png"}
						heading={t("aboutUs.s3.heading")}
						aspectRatio="aspect-[1374/916]"
					>
						<div>
							<p className="mb-6">
								<Trans i18nKey="aboutUs.s3.p1" components={{ strong: <strong /> }} />
							</p>
						
							<p>
								<Trans i18nKey="aboutUs.s3.p2" components={{ 
									strong: <strong />,
									span: <span className="my-6 block" />
								}} />
							</p>
							<p>{t('aboutUs.s3.p3')}</p>
							<p>{t('aboutUs.s3.p4')}</p>
							<p>{t('aboutUs.s3.p5')}</p>
							<p>{t('aboutUs.s3.p6')}</p>
							<p>{t('aboutUs.s3.p7')}</p>
							<p>
								<Trans i18nKey="aboutUs.s3.p8" components={{ 
									strong: <strong />,
									span: <span className="my-6 block" />
								}} />
							</p>

							<p className="mt-6">
								<Trans i18nKey="aboutUs.s3.p9" components={{ 
									strong: <strong />,
									a: <a href="#contact" className="underline text-leo-brown" />
								}} />
							</p>
						</div>
					</MediaWithText>
				</div>

				{servicesFiltered.map((p, idx) => (
					<div 
						className="mt-12"
						key={"leistung-" + idx}
					>
						<MediaWithText
							textInLeft={idx % 2 === 0}
							imageSrc={p.img}
							heading={p.heading}
							aspectRatio="aspect-[1920/1276]"
						>
							<div>
								<p className="mb-6">
									<Trans
										defaults={p.desc}
										components={{
											strong: <strong />
										}}
									/>
								</p>
								<ul className="pl-10 mb-6">
									{p.bullets.map((b, idx) => (
										<li key={idx} className="list-disc">
											{b}
										</li>
									))}
								</ul>
								<p className="mb-6">{p.moreText}</p>
								<div className="max-w-[200px]">
									<Button
										text={t('aboutUs.enquireNow')}
										transparent={false}
										border={false}
										href={"/ueber-uns#contact"}
										className="mt-5 rounded-[10px] font-bold bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent"
										padding={"px-6 py-[14px]"}
									/>
								</div>
							</div>
						</MediaWithText>
					</div>

					
				))}

				<div className="my-12">
					<HomeBanner />
				</div>
			</div>
			<ContactFormSection />
		</>
	);
}

export default ContactUsContent;
